import React, { useState } from "react";
import { tt } from "../../utils/i18n/i18n";
import KC_Tabs from "../../designsystem/KC_Tabs/KC_Tabs";
import KC_Separator from "../../designsystem/KC_Separator/KC_Separator";
import { KC_Sizes } from "../../designsystem/ds_commons";
import { OptinsTable } from "./components/OptinsTable";
import { FormDataTable } from "./components/FormDataTable";
import { FeedbacksTable } from "./components/FeedbacksTable";
import DateRangePickerReduxWrapper from "../../components/DateRangePickerReduxWrapper";
import KC_Heading2 from "../../designsystem/typography/KC-Heading/KC_Heading2";
import WinnersTable from "./components/WinnersTable";
import { ManagedAccountDropdown } from "../../components/ManagedAccountDropdown/ManagedAccountDropdown";

export const FormData = () => {
  const [activeTab, setActiveTab] = useState("winners");

  const tabItems = [
    {
      name: tt("winners"),
      value: "winners"
    },
    {
      name: tt("optins"),
      value: "optins"
    },
    {
      name: tt("form_data"),
      value: "form_data"
    },
    {
      name: tt("feedbacks"),
      value: "feedbacks"
    }
  ];

  return (
    <div className="d-flex flex-column p-4 dashboard-v2">
      <div className="d-flex flex-column flex-sm-row mb-4">
        <ManagedAccountDropdown />
        <div className="flex-grow-1"></div>
        <DateRangePickerReduxWrapper />
      </div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <KC_Heading2 text={tt("data")} />
        <div className="d-flex flex-grow-1">&nbsp;</div>
      </div>

      <div className="w-100">
        <KC_Tabs
          items={tabItems}
          onSelect={setActiveTab}
          initialSelectedIndex={0}
        />
      </div>

      <KC_Separator size={KC_Sizes.sm} />

      <div className="tab-content">
        {activeTab === "optins" && <OptinsTable />}
        {activeTab === "form_data" && <FormDataTable />}
        {activeTab === "feedbacks" && <FeedbacksTable />}
        {activeTab === "winners" && <WinnersTable />}
      </div>
    </div>
  );
};
